import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// import {arrayOf, number, bool, string, func, object} from 'prop-types';
// import { Cookies } from 'react-cookie';

import Header from '../components/Header/Header.jsx';
import Banner from '../components/Banner/Banner.jsx';
import Notice from '../components/Banner/Notice.jsx';
import Guide from '../components/Forms/Guide.jsx';
import Ratings from '../components/Ratings/Ratings.jsx';
import MedicareGuide from '../components/Forms/MedicareGuide.jsx';
import Footer from '../components/Footer/Footer';
import StartOver from '../components/Header/StartOver.jsx';

import * as RouteHelpers from '../helpers/routes';
import * as GeneralHelpers from '../helpers/general';
import { quizPaths } from '../helpers/quiz';
import * as A from '../redux/actions';

const mapStateToProps = state => {
  return {
    routing: state.routing,
    quiz: state.quiz,
    page: state.pageOverride,
    rest: state.rest
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStep: (step) => {
      dispatch(A.setStep(step));
    },
    fetchCounties: () => {
      A.fetchCounties({dispatch});
    },
    startOver: () => {
      dispatch(A.startOver());
    },
    setFieldValue: (fieldKey, fieldValue) => {
      dispatch(A.setFieldValue(fieldKey, fieldValue));
    },
    updateZip: ({zip, county} = {}) => {
      dispatch(A.updateZip({zip, county}));
    },
    resetQuote: () => {
      dispatch(A.resetQuote());
    },
    changeSelectedPlan: (planObj) => {
      dispatch(A.changeSelectedPlan(planObj));
    },
    updateHeaderHours: (hours) => {
      dispatch(A.updateHeaderHours(hours));
    },
    updateTopBanner: (topBanner) => {
      dispatch(A.updateTopBanner(topBanner));
    },
    toggleInQuiz: (state) => {
      dispatch(A.toggleInQuiz(state));
    },
    toggleInResults: (state) => {
      dispatch(A.toggleInResults(state));
    },
    updateHeaderPremium: (premium) => {
      dispatch(A.updateHeaderPremium(premium));
    },
    updateHeaderPhone: (phone) => {
      dispatch(A.updateHeaderPhone(phone));
    },
    updateHeaderScroller: (scrollButton) => {
      dispatch(A.updateHeaderScroller(scrollButton));
    },
    postResults: ({fieldValues, url}) => {
      A.postResults({dispatch, results: fieldValues, url});
    },
    updateResultsRatings: (ratings, ratingsProps) => {
      dispatch(A.updateResultsRatings(ratings, ratingsProps));
    },
    updateResultsFooter: (footer, footerProps) => {
      dispatch(A.updateResultsFooter(footer, footerProps));
    }
  };
};

class Template extends Component {
  constructor (props) {
    super(props);

    this._handleShowStartOverModal = this._handleShowStartOverModal.bind(this);
    this._startOver = this._startOver.bind(this);
    this._setModalStateClosed = this._setModalStateClosed.bind(this);
    this.handleCloseModals = this._closeModals.bind(this);
    this.handleOpenModal = this._openModal.bind(this);
    this._handleLogoClick = this._handleLogoClick.bind(this);
  }

  state = { // include everything you think will be common to most pages' props
    ...RouteHelpers.setVarsBasedOnRoute(
      this.props.match.params.route, this.props.match.params.subroute)
  };

  static getDerivedStateFromProps (props, state) {
    const {pathname} = props;
    const stateDiff = GeneralHelpers.getObjectDiff(props, state);
    const splitPath = pathname.split('/');
    const route = splitPath[1] || '/';
    let subroute = splitPath[2] || '';
    let stateFromRoute = state;

    if (route !== state.route || // if the props indicate a route change, or
      (!!subroute && subroute !== state.subroute) || // props have new subroute that doesn't match, or
      pathname !== state.pathname || // another way of validating whether the route has changed
      (!!state.subroute && state.subroute !== subroute) // state has subroute that doesn't match
    ) { // checking both lines above b/c subroute might be undefined in either state or props
      if (_.isUndefined(subroute)) {
        const splitPath = pathname.split('/');
        if (!_.isUndefined(splitPath)) subroute = splitPath[2];
      }

      stateFromRoute = _.merge({},
        RouteHelpers.setVarsBasedOnRoute(route, subroute),
        { subroute });
    }

    let newState = {};

    for (let k in stateDiff) {
      if (props[k]) newState[k] = props[k];
    }

    _.pick(_.merge(newState, stateFromRoute), _.identity); // removes empty keys while merging

    if (_.isUndefined(newState.route)) {
      newState.route = route;
      const pathIdx = RouteHelpers.getPathIndexFromUrl('find-a-plan');
      if (pathIdx > 0) {
        newState.route = RouteHelpers.getPathValFromIndex(pathIdx - 1);
      } else newState.route = 'home';
    }

    if (!newState.page.inQuiz && state.page.inQuiz && props.quiz.step !== 1) {
      props.setStep(1); // when navigating OUT of quiz flow, set step back to 1
      props.toggleInResults(false); // and indicate that we're not on a results page
      _.merge(newState, RouteHelpers.quizDefaults);
    }

    // override default visibility of items for quiz views with reducer values and new state values for the same:
    if (newState.page.inQuiz) newState.page.show = _.merge({}, newState.page.show, props.quiz.show);
    newState.page.show.startOver = _.clone(state.page.show.startOver);

    // for (let k in newState) if (_.isFunction(newState[k])) delete newState[k];
    delete newState['CTA'];

    _.merge(newState, {page: props.page}); // merge any values from the reducer into the state

    if (!newState.page.inQuiz && props.quiz.step === 1 && props.routing.pathname === '/find-a-plan/') {
      // Correct the value of inQuiz in the case where it's not reflected accurately on find a plan:
      props.toggleInQuiz(true);
    }

    const objDiff = GeneralHelpers.difference(state, newState);
    const diffKeys = Object.keys(objDiff);
    const hasDiff = (diffKeys.length > 0 && diffKeys[0] !== 'CTA');

    if (hasDiff && (stateDiff.length || (
      newState.route !== state.route) || (newState.subroute !== state.subroute)
    )) {
      return newState;
    }

    return null; // if no state mutations are required at this time
  }

  componentDidMount () {
    if (!this.props.rest.counties.length) this.props.fetchCounties();
  }

  _handleShowStartOverModal () {
    this._setModalStateClosed();
    this.setState(_.merge({}, this.state, {
      'page': {
        'show': {
          'startOver': true
        }
      }
    }));
  }

  _setModalStateClosed () {
    this.setState(_.merge({}, this.state, {
      'page': {
        'show': {
          'guide': false,
          'maps': false,
          'yesnomaybe': false,
          'options': false,
          'startOver': false
        }
      }
    }));
  }

  _openModal (key) {
    const modalType = (_.isString(key) ? key : 'guide');
    const newState = _.merge({}, this.state, {
      'page': {
        'show': {
          'guide': false,
          'maps': false,
          'yesnomaybe': false,
          'options': false,
          'startOver': false
        }
      }
    });

    newState.page.show[modalType] = true;
    this.setState(newState);
    RouteHelpers.history.push(this.state.page.view.url + modalType);
  }

  _closeModals () {
    this._setModalStateClosed();
    RouteHelpers.history.push(this.state.page.view.url);
  }

  _startOver () {
    const p = _.clone(this.props);
    this._setModalStateClosed();
    p.startOver();
    p.resetQuote();
    p.updateZip();
    p.toggleInQuiz(true);
    p.toggleInResults(false);
    p.updateTopBanner(null);
    p.updateHeaderScroller(null);
    p.updateHeaderPremium(null);
    p.updateResultsFooter(false);
    p.updateResultsRatings(false);

    if (p.match.params.route === 'quote' || p.pathname.indexOf('/quote/') > -1) {
      if (p.quiz.fieldValues.QuizRoute) {
        window.location.href = '/' + p.quiz.fieldValues.QuizRoute + '/find-a-plan/';
      } else window.location.href = '/';
    } else RouteHelpers.history.push(RouteHelpers.newStepIndexForUrl(1));
  }

  _handleLogoClick () {
    const p = _.clone(this.props);
    if (p.route === 'quote' || p.match.params.route === 'quote' ||
      p.pathname.indexOf('/quote/') > -1) {
      window.location.href = '/';
    } else {
      this._setModalStateClosed();
      p.toggleInQuiz(false);
      p.toggleInResults(false);
      p.updateHeaderScroller(null);
      p.updateHeaderScroller(null);
      p.updateHeaderPremium(null);
      p.updateResultsRatings(true);
      p.updateResultsFooter(true);
      window.location.href = '/';
      // RouteHelpers.history.push('/');
    }
  }

  render () {
    const s = _.clone(this.state);
    const p = _.clone(this.props);
    const View = s.page.view.class;
    const childViewProps = _.merge({}, s.page.view.props, {
      page: s.page,
      quiz: p.quiz,
      rest: p.rest,
      openModal: this.handleOpenModal,
      closeModal: this.handleCloseModals,
      route: s.route,
      subroute: s.subroute,
      updateZip: p.updateZip,
      countyKey: s.countyKey,
      setFieldValue: p.setFieldValue,
      setStep: p.setStep,
      startOver: p.startOver,
      changeSelectedPlan: p.changeSelectedPlan,
      updateHeaderHours: p.updateHeaderHours,
      updateTopBanner: p.updateTopBanner,
      toggleInQuiz: p.toggleInQuiz,
      toggleInResults: p.toggleInResults,
      updateHeaderPremium: p.updateHeaderPremium,
      updateHeaderPhone: p.updateHeaderPhone,
      updateHeaderScroller: p.updateHeaderScroller,
      postResults: p.postResults,
      updateResultsFooter: p.updateResultsFooter,
      updateResultsRatings: p.updateResultsRatings
    });
    const links = s.page.banner.links || [];
    let articleClasses = '';
    let quiz = s.page.inQuiz;
    let totalSteps = 8;
    if (p.quiz.fieldValues.QuizRoute === 'medicare') totalSteps = 4;
    if (p.quiz.fieldValues.QuizRoute === 'small-business') totalSteps = 4;
    if (p.quiz.fieldValues.QuizRoute === 'small-business-look-again') totalSteps = 4;

    if (typeof quiz === 'undefined') quiz = s.quiz.inQuiz;

    if (s.page.show.guide) articleClasses += 'guide';
    if (quiz) articleClasses += ' quiz';
    if (s.page.inResults) articleClasses += 'resultsContainer';
    if (s.page.view.url === '/medicare/') { articleClasses += ' medicare'; }
    if (s.page.view.url === '/small-business-look-again/') { articleClasses += ' lookagain'; }
    if (s.page.view.url === '/hudson-valley/') { articleClasses += ' hudson-valley'; }
    if (s.page.view.url === '/' || s.page.view.url === '/child-health-plus/' || s.page.view.url === '/individuals-families/' || s.page.view.url === '/essential/' || s.page.view.url === '/government-programs/' || s.page.view.url === '/medicaid/') articleClasses += ' banner';

    return (
      <div id='template' className={articleClasses}>
        <article>
          <Helmet>
            <title>{s.page.meta.title}</title>
            <meta name='description' content={s.page.meta.description} />
            <link rel='canonical' href={s.page.meta.canonical} />
          </Helmet>

          {s.page.show.header && <Header
            properties={s.page.header}
            getHeaderHeight={_.noop}
            inQuiz={quiz}
            inResults={s.page.inResults}
            route={s.route}
            handleShowStartOverModal={this._handleShowStartOverModal}
            handleLogoClick={this._handleLogoClick}
          >
            {s.CTA}
          </Header>}

          {(quiz && p.quiz.step > 1 &&
            quizPaths[s.route] &&
            p.quiz.step < quizPaths[s.route].steps.length) &&
            <button
              className='btn grey rounded start-over'
              onClick={this._handleShowStartOverModal}
            >Start Over</button>}

          {quiz && quizPaths[s.route] && <div id='progress'><span style={{width: p.quiz.step / totalSteps * 100 + '%'}} /></div>}

          {s.page.show.banner && <Banner
            heading={s.page.banner.heading}
            subHead={s.page.banner.subhead}
            style={s.page.banner.styles}
          >
            <ul>
              {links.map((link, idx) => <li
                key={idx}
              >{link}</li>)}
            </ul>
          </Banner>}

          {s.page.show.notice && <Notice
            question={s.page.notice.question}
            intro={s.page.notice.intro}
            title={s.page.notice.title}
            openModal={childViewProps.openModal}
            url={s.page.view.url + 'guide'}
          />}

          {s.page.show.notice && <Guide
            area={s.page.guide.area}
            question={s.page.notice.question}
            closeModal={this.handleCloseModals}
            show={s.page.show.guide}
            guideTitle={s.page.notice.title}
          />}

          {s.page.show.maps && <MedicareGuide
            area={s.page.maps.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.maps}
            guideTitle={s.page.maps.title}
          /> }

          {s.page.show.ynm && <MedicareGuide
            area={s.page.ynm.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.ynm}
            guideTitle={s.page.ynm.title}
          /> }

          {s.page.show.options && <MedicareGuide
            area={s.page.options.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.options}
            guideTitle={s.page.options.title}
          /> }

          {s.page.show.triplezero && <MedicareGuide
            area={s.page.triplezero.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.triplezero}
            guideTitle={s.page.triplezero.title}
          /> }

          {s.page.show.fivestars && <MedicareGuide
            area={s.page.fivestars.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.fivestars}
            guideTitle={s.page.fivestars.title}
          /> }

          {s.page.show.upstateny && <MedicareGuide
            area={s.page.upstateny.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.upstateny}
            guideTitle={s.page.upstateny.title}
          /> }

          {s.page.show.optionsoffer && <MedicareGuide
            area={s.page.optionsoffer.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.optionsoffer}
            guideTitle={s.page.optionsoffer.title}
          /> }

          {s.page.show.options1 && <MedicareGuide
            area={s.page.options1.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.options1}
            guideTitle={s.page.options1.title}
          /> }

          {s.page.show.options2 && <MedicareGuide
            area={s.page.options2.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.options2}
            guideTitle={s.page.options2.title}
          /> }

          {s.page.show.options3 && <MedicareGuide
            area={s.page.options3.area}
            closeModal={this.handleCloseModals}
            show={s.page.show.options3}
            guideTitle={s.page.options3.title}
          /> }

          {s.route && <View {...childViewProps} key={s.pathname} />}
          {s.page.show.ratings && !quiz &&
          <Ratings {...s.page.show.ratingsProps} /> }
          {s.page.show.footer &&
          <Footer {...s.page.show.footerProps} />}
          {s.page.show.startOver && <StartOver
            closeModal={this._setModalStateClosed}
            startOver={this._startOver}
          />}
        </article>
      </div>
    );
  }
}

Template.propTypes = { // validate props expected
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Template));
